import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getNewsletterById } from '../../api';

const Newsletter = () => {
  const [newsletter, setNewsletter] = useState({});
  const { id } = useParams();

  const fetchNewsLetter = async () => {
    try {
      const response = await getNewsletterById(id);
      console.log('Fetching newsletter with ID:', id);
      setNewsletter(response);
      console.log('Fetched newsletter:', response);
    } catch (error) {
      console.error("Error fetching newsletters:", error);
      return [];
    }
  };

  useEffect(() => {
    if (id) {
      fetchNewsLetter();
    }
  }, [id]);

  return (
    <div className='news-page-container w-full h-fit p-8 md:p-16'>
      <article className='max-w-[100%] md:max-w-[85%] mx-auto'>
        <div className='text-3xl text-center mb-8'>{newsletter?.title}</div>
        <div dangerouslySetInnerHTML={{ __html: newsletter?.content }} />
      </article>
    </div>
  )
};

export default Newsletter;